import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";

import { AppContext } from "../../components/provider/AppContext";
import styles from "./TemplateLoader.module.css";
import { useSwipeable } from "react-swipeable";
import CustomColorSelect from "../../components/dropdown/CustomSelect";
import { use } from "react";

const TemplateLoader = () => {
  const colorSelection = [
    "Black",
    "Blue",
    "Brown",
    "Burgundy",
    "Gray",
    "Green",
    "Ivory",
    "Jade",
    "Khaki",
    "Pink",
    "Red",
    "Yellow",
  ];
  const bindColorSelection = ["Gold", "Silver", "Black", "White", "Rose Gold"];
  const sizeSelection = [
    "Extra Small - 6x8",
    "Small - 7x9",
    "Medium - 7.5x10",
    "Large - 8.5x11",
  ];
  const [templateSelected, setTemplateSelected] = useState("No Template");
  const [bindColor, setBindColor] = useState("No color");
  const [finishColor, setFinishColor] = useState("No color");
  const [baseColor, setBaseColor] = useState("No color");
  const navigate = useNavigate();

  const [colorSelected, setColorSelected] = useState("No color");
  const { appData, setAppData } = useContext(AppContext);
  const passContext = (key, value) => {
    setAppData({ ...appData, [key]: value });
    localStorage.setItem("appData", JSON.stringify(appData));
  };
  const navigator = useNavigate();
  const isDisabled = () => {
    return templateSelected === "No Template" || colorSelected === "No size";
  };
  useEffect(() => {
    const updatedData = {
      ...appData,
      nextPageText: "Font",
      backPageText: "Color",
      nextPageLink: "font",
      backPageLink: "colorSelection",
      currentPage: 1,
    };

    setAppData(updatedData);
  }, []);

  useEffect(() => {
    if (appData) {
      if (appData?.colorSelected && appData?.colorSelected !== "") {
        setColorSelected(appData.colorSelected);
      }
      if (appData?.bindColor && appData?.bindColor !== "") {
        setBindColor(appData.bindColor);
      }
      if (appData?.finishColor && appData?.finishColor !== "") {
        setFinishColor(appData.finishColor);
      }
      if (appData?.baseColor && appData?.baseColor !== "") {
        setBaseColor(appData.baseColor);
      }
    }
  }, [appData]);
  const handlers = useSwipeable({
    onSwipedLeft: () => navigate("/font"), // Swipe left to go to the About page
    onSwipedRight: () => navigate("/colorSelection"), // Swipe right to go to the Home page
  });
  return (
    <>
      <div
        className={`container-fluid d-flex flex-column justify-content-center align-items-center gap-10 ${styles["fade-in"]}`}
        style={{ width: "94vw", height: "70vh" }}
        {...handlers}
      >
        <form>
          <div className={`form-group `}>
            <div className="d-flex flex-column gap-2">
              <label htmlFor="selectTemplate">Planner Color: </label>
              {/* <select
              onChange={({ target }) => setColorSelected(target.value)}
              className="form-control"
              id="selectTemplate"
              values={colorSelected}
            >
              <option value={"No size"} selected hidden>
                Please Select a Size
              </option>
              {colorSelection.map((color) => {
                return (
                  <option
                    key={color}
                    value={color}
                    style={{ backgroundColor: color, color: "white" }}
                  >
                    {color}
                  </option>
                );
              })}
            </select> */}
              {
                <CustomColorSelect
                  colorSelection={colorSelection}
                  colorSelected={colorSelected}
                  customId={"colorSelected"}
                  customStyle={{ marginTop: "-0.6rem" }}
                  contextUpdater={passContext}
                />
              }
            </div>
            <br></br>

            <div className="d-flex flex-column gap-2">
              <label htmlFor="selectTemplate">Bind Color: </label>
              {
                <CustomColorSelect
                  colorSelection={bindColorSelection}
                  colorSelected={bindColor}
                  customId={"bindColor"}
                  customStyle={{ marginTop: "-0.6rem" }}
                  contextUpdater={passContext}
                />
              }
            </div>
            <br></br>

            <div className="d-flex flex-column gap-2">
              <label htmlFor="selectTemplate">
                Pick your base color (Shows on the inside of the front and back
                covers){" "}
              </label>
              {
                <CustomColorSelect
                  colorSelection={["White", "Black"]}
                  colorSelected={baseColor}
                  customId={"baseColor"}
                  customStyle={{ marginTop: "-0.6rem" }}
                  contextUpdater={passContext}
                />
              }
            </div>
            <br></br>

            {/* <label htmlFor="selectTemplate">
              Pick what color bind would you like:{" "}
            </label>
            <Form
              className="gap-1"
              onChange={({ target }) => setBindColor(target.value)}
            >
              <Form.Check
                type="radio"
                label="Gold"
                value="Gold"
                checked={bindColor === "Gold"}
              />
              <Form.Check
                type="radio"
                label="Silver"
                value="Silver"
                checked={bindColor === "Silver"}
              />
              <Form.Check
                type="radio"
                label="Black"
                value="Black"
                checked={bindColor === "Black"}
              />
              <Form.Check
                type="radio"
                label="White"
                value="White"
                checked={bindColor === "White"}
              />
              <Form.Check
                type="radio"
                label="Rose Gold"
                value="Rose Gold"
                checked={bindColor === "Rose Gold"}
              />
            </Form>
            <br></br>
            <label htmlFor="selectTemplate">
              Pick your base color (Shows on the inside of the front and back
              covers){" "}
            </label>
            <Form
              className={`d-flex gap-2`}
              onChange={({ target }) => setBaseColor(target.value)}
            >
              <Form.Check
                type={"radio"}
                label="Black"
                value={"Black"}
                checked={baseColor === "Black"}
              />
              <Form.Check
                type={"radio"}
                label="White"
                value={"White"}
                checked={baseColor === "White"}
              />
            </Form> */}
            <label htmlFor="selectTemplate">
              Pick What Finish You Would Like{" "}
            </label>
            <Form
              className={`d-flex gap-2`}
              onChange={({ target }) => {
                setFinishColor(target.value);
                passContext("finishColor", target.value);
              }}
              values={finishColor}
            >
              <Form.Check
                type={"radio"}
                label="Glossy"
                value={"Glossy"}
                checked={finishColor === "Glossy"}
              />
              <Form.Check
                type={"radio"}
                label="Matte"
                value={"Matte"}
                checked={finishColor === "Matte"}
              />
            </Form>
            <br></br>
          </div>
        </form>
      </div>
    </>
  );
};
export default TemplateLoader;
